
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tos/[[...id]]",
      function () {
        return require("private-next-pages/tos/[[...id]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tos/[[...id]]"])
      });
    }
  